/** Brave on iOS injects a Firefox-derived bridge and a wallet provider into every page, and both throw as our origin. */
export const BROWSER_INJECTED_ERROR_PATTERNS = ['__firefox__', 'window.ethereum']
